<template>
  <div style=" text-align: center;
    background-color: #fff;
    border-radius: 20px;
    width: 300px;
    height: 350px;
    position: absolute;
    left: 42%;
    top: 40%;
    transform: translate(-50%,-50%);
">

    <div class="loginContainer">
      <H1 style="margin-top: 20px;">翔鲸进销存管理系统</H1>
      <a-form class="cont" :model="formState" name="basic" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }"
        autocomplete="off" @finish="onFinish" @finishFailed="onFinishFailed">
        <a-form-item label="用户名(电话)" name="telephone" :rules="[{ required: true, message: '请输入用户名!' }]">
          <a-input v-model:value="formState.telephone" style="width: 300px;" />
        </a-form-item>

        <a-form-item label="密码" name="password" :rules="[{ required: true, message: '请输入密码!' }]">
          <a-input-password v-model:value="formState.password" style="width: 300px;" />
        </a-form-item>

        <a-form-item :wrapper-col="{ offset: 8, span: 24 }" style="margin-top: 50px;">
          <a-button type="primary" html-type="submit">确认登录</a-button>
        </a-form-item>
      </a-form>

    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, getCurrentInstance } from 'vue';
import { message } from 'ant-design-vue';
export default defineComponent({
  setup() {
    const { ctx } = getCurrentInstance()
    const formState = reactive({
      telephone: '',
      password: '',
      remember: true,
    });
    const onFinishFailed = errorInfo => {
      console.log('Failed:', errorInfo);
    };
    return {
      formState,
      onFinishFailed,
    };
  },

  mounted() {
   //绑定事件
		window.addEventListener("keydown", this.keyDown);
  },
  // created(){
  //     fetch('http://192.168.10.252:8088/get/aweat', {
  //                   method: 'POST',
  //                   headers: {
  //                       'Content-Type': 'application/json' 
  //                       },
  //                   body: JSON.stringify({
  //                       idcard:"441900199005310175",
  //                       exam_cardno:"20240313357202"
  //                   })
  //               })
  //               .then(res => res.json())
  //               .then(data => {
                    
  //               }).catch(() => {
                  
  //               })
  // },
  methods: {
    onFinish() {
      this.Post(this.Api.login, this.formState).then(response =>{
        if(response.Code == 1){
          message.success(response.Msg);
          localStorage.setItem('userMenus', JSON.stringify(response.Data))
          this.$store.commit('SETMENU', response.Data)
          this.$store.commit('ADDROUTES')
          this.$router.push({ path: '/ggmanger/Message' })
          localStorage.setItem('czname', response.name)
          localStorage.setItem('czid', response.nameID)
        }
        else{
          message.success(response.Msg);
        }
      })
    },
    //回车登录
		// keyDown(e) {
    //     //判断按下是否是回车键
    //     if (e.keyCode == 13) {
    //       if(this.formState.password == "" || this.formState.telephone == ""){
    //         message.error("请输入账号密码！")
    //         return false
    //       }else{
    //        this.onFinish() 
    //       }
          
    //     }
    //   },
  },

});
</script>
<style>
.loginContainer {
  border-radius: 15px;
  background-clip: padding-box;
  width: 550px;
  height: 350px;
  padding: 15px 35px 15px 35px;
  background: #fefefe;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}

.cont {
  margin-top: 13%;
  margin-right: 20%;
}
</style>